import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideEffects } from '@ngrx/effects';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { ErrorInterceptor } from '../@core/http/error.interceptor';
import { authInterceptor } from '../@core/interceptors/auth.interceptor';
import { LocalStorageService } from '../@core/services/local-storage.service';
import { appStateReducer } from '../@store/app.reducers';
import { appStateKey } from '../@store/app.state.interface';
import * as clientsEffects from '../@store/clients/clients.effects';
import * as ItemProcessesEffects from '../@store/products/item-processes/item-processes.effects';
import * as quotesEffects from '../@store/quotes/quotes.effects';
import * as userEffects from '../@store/user/user.effects';
import * as ordersEffects from '../@store/orders/orders.effects';
import { caNumbersReducer } from '../@store/products/ca-numbers/ca-numbers.reducer';
import * as caNumbersEffects from '../@store/products/ca-numbers/ca-numbers.effects';
import { ordersReducer } from '../@store/orders/orders.reducer';

import { routes } from './app.routes';
import { provideNativeDateAdapter } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideStore({
      router: routerReducer,
    }),
    provideState(appStateKey, appStateReducer),
    provideRouterStore(),
    provideEffects([
      userEffects,
      quotesEffects,
      ItemProcessesEffects,
      clientsEffects,
      caNumbersEffects,
      ordersEffects
    ]),
    provideState('caNumbers', caNumbersReducer),
    provideState('orders', ordersReducer),
    provideHttpClient(withFetch(), withInterceptorsFromDi(), withInterceptors([authInterceptor])),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    importProvidersFrom(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    LocalStorageService,
    provideNativeDateAdapter(),
  ],
};
